import { type CountryCode } from 'libphonenumber-js'
import { getCountryCallingCode } from 'react-phone-number-input'

export const formatCountryCallingCode = (countryCode: CountryCode) => {
  return `+${getCountryCallingCode(countryCode)}`
}
